import {
  GET_PENDING_PAYMENT_REQUEST_LIST_ERROR,
  GET_PENDING_PAYMENT_REQUEST_LIST_START,
  GET_PENDING_PAYMENT_REQUEST_LIST_SUCCESS,
} from 'constants/action-types/transactions/getPendingPaymentRequestList';

export default (state, { type, payload }) => {
  switch (type) {
    case GET_PENDING_PAYMENT_REQUEST_LIST_START:
      return {
        ...state,
        pendingPaymentRequest: {
          ...state.pendingPaymentRequest,
          loading: true,
          error: null,
        },
      };
    case GET_PENDING_PAYMENT_REQUEST_LIST_ERROR:
      return {
        ...state,
        pendingPaymentRequest: {
          ...state.pendingPaymentRequest,
          error: payload,
          loading: false,
        },
      };
    case GET_PENDING_PAYMENT_REQUEST_LIST_SUCCESS:
      return {
        ...state,
        pendingPaymentRequest: {
          ...state.pendingPaymentRequest,
          error: null,
          loading: false,
          data: payload,
        },
      };
    default:
      return null;
  }
};
